let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5kUI8")).then(() => parcelRequire('89uEU'));